import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { FieldSwitch } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import styles from './buttonOption.module.scss';
export function ButtonOption({ onChange, option }) {
    const handleChange = useCallback(() => {
        onChange(Object.assign(Object.assign({}, option), { active: !option.active }));
    }, [onChange, option]);
    const fieldId = `button-${option.button}`;
    return (_jsxs("div", Object.assign({ className: styles.root }, { children: [_jsxs("label", Object.assign({ htmlFor: fieldId }, { children: ["Press ", option.button] })), _jsx(FieldSwitch, { id: fieldId, input: {
                    checked: option.active,
                    name: 'active',
                    value: 'active',
                    onChange: handleChange,
                } })] })));
}
